/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Time/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Time({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Order/Content/Time"
  
}) {
let orderCreatedAtValueData = fromData.useDataValue({ viewPath,
context: 'order',
path: 'created_at',
})
let aggregateData = fromHelpers.formatDate(orderCreatedAtValueData)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let orderCreatedAtValueData1 = fromData.useDataValue({ viewPath,
context: 'order',
path: 'created_at',
})
let aggregateData1 = fromHelpers.formatYear(orderCreatedAtValueData1)
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="bold"
 color={dtColorsNeutral500}
 data="order.created_at"
 aggregate="helpers.js formatDate"
 text={aggregateData}
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="semibold"
 color={dtColorsNeutral500}
 data="order.created_at"
 aggregate="helpers.js formatYear"
 text={aggregateData1}
/>
{children}
</React.Fragment>)
}